export default {
  api_error_esdh_export: 'Det er ikke muligt at journalisere dokumenter til mere end én kommune ad gangen.',
  api_error_generic: 'Der skete en fejl',
  api_error_event: 'Noget gik galt: Begivenheden er ikke længere tilgængelig',
};
